import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_Action } from '@app/pathway-shared';
import { ModuleFE_OrderGroup } from './ModuleFE_OrderGroup.js';
import { DBItemDropDownMultiSelector, DBItemDropDownMultiSelector_DBPointer } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { ModuleFE_Action } from '../action/index.js';
const Props_DropDown = {
    module: ModuleFE_OrderGroup,
    modules: [ModuleFE_OrderGroup],
    mapper: item => [item.name],
    placeholder: 'Choose an OrderGroup',
    renderer: item => _jsx("div", { className: "ll_h_c", children: item.name })
};
export const DropDown_OrderGroup = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_OrderGroup,
    itemRenderer: (item, onDelete) => {
        return _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), item?.name ?? 'Not Found'] });
    },
    uiSelector: DropDown_OrderGroup.selectable,
});
export const MultiSelect_OrderGroup = TS_MultiSelect_V2.prepare(Props_MultiSelect);
const Props_DropDown_OrderGroupItems = {
    placeholder: 'Choose an Order Group Item',
    pointerProps: {
        [DBDef_Action.dbKey]: {
            module: ModuleFE_Action,
            mapper: order => [order.item.name],
            renderer: order => _jsx("div", { className: "ll_h_c", children: order.item.name ?? 'N/A' }),
        },
    },
};
export const DropDown_OrderGroupItems = GenericDropDownV3.prepare_DBPointers(Props_DropDown_OrderGroupItems);
const Props_MultiSelect_OrderGroupItems = DBItemDropDownMultiSelector_DBPointer.props({
    uiSelector: DropDown_OrderGroupItems.selectable,
    pointerProps: {
        [DBDef_Action.dbKey]: {
            module: ModuleFE_Action,
            mapper: order => [order.item.name],
            renderer: (pointer, onDelete, disabled) => {
                const order = ModuleFE_Action.cache.unique(pointer?.id);
                return _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), order?.name ?? 'Not Found'] });
            },
        }
    }
});
export const MultiSelect_OrderGroupItems = TS_MultiSelect_V2.prepare(Props_MultiSelect_OrderGroupItems);
//# sourceMappingURL=ui-components.js.map